import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { getDirectorAdditionalInfoAsync } from '../../../../store/slices/addDirector/getDirectorAdditionalInfoSlice';

const SHOW_ON_ROUTES = ['/app/dashboard'];

export default function useDirectorsAdditionalInfoPrompt() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { status, value } = useAppSelector(
    (state) => state.getDirectorAdditionalInfo,
  );

  const businessIdFromStorage = localStorage.getItem('businessId') as string;

  useEffect(() => {
    if (businessIdFromStorage)
      dispatch(
        getDirectorAdditionalInfoAsync({
          approvalStatus: 'information_requested',
        }),
      );
  }, [dispatch, businessIdFromStorage]);

  const showBanner =
    status === 'success' &&
    Boolean(value?.data?.length) &&
    SHOW_ON_ROUTES.some((route) => location.pathname.includes(route));

  return { showBanner };
}
